export const pageNames = {
    SearchComponent: 'SearchComponent',
    TicketSelectComponent: 'TicketSelectComponent',
    PayTicketComponent: 'PayTicketComponent',
    AffirmationComponent: 'AffirmationComponent',
    ViewDocComponent: 'ViewDocComponent',
    SampleTicketsNassauComponent: 'SampleTicketsNassauComponent',
    ReceiptComponent: 'ReceiptComponent',
    MaintenanceComponent: 'MaintenanceComponent'
};
